export function sensorCheck() {
    return (typeof window !== 'undefined' && typeof sensorsDataAnalytic201505 === "object" && typeof sensorsDataAnalytic201505.track === "function")
  }
  
  export function sensorGoCreator(key = 'track') {
    if (sensorCheck()) return window.sa[key]
    return null
  }
  
  


// WEBPACK FOOTER //
// ./common/Utils/sensor-wrapper/src/globalSensorHandler.js